<template lang="pug">
div
  v-menu(v-model="show" rounded="lg" allow-overflow :close-on-content-click="false" :close-on-click="!openDialog" offset-y :attach="attach" max-height="345")
    template(#activator="{ on, attrs }")
      v-sheet.text-md.round-xl.border-menu(v-bind="attrs" v-on="on" flat outlined height="48" min-width="150")
        .d-flex.align-center.fill-height.px-4
          div.d-flex.align-center.flex-grow-1(v-if="value")
            v-icon.mr-2(size="11" :color="value.iconColor") $yzi-circle
            .text-sm {{ value.name }}
          .text-sm.flex-grow-1.neutral500--text.text-left(v-else) Select inventory list
          v-icon.ml-2(size="24") $yzi-chevron-down
    .text-xs.white
      .search-input
        v-text-field.mb-2.mx-4.text-sm.round-xl(v-model="itemName" outlined :placeholder="$t('search_or_add_new')" dense hide-details autofocus)
        v-divider
        .d-flex.align-center.px-4.py-3.clickable.hover-bg(@click="openAddNewListDialog = true")
          v-icon.mr-2(size="15") mdi-plus
          .text-sm Add new list
        v-divider
        .d-flex.align-center.justify-space-between.px-4.py-3
          .font-semibold.mr-6 Existing list
          y-pagination(v-model="page" :pageSize="pageSize" :count="count" :loading="isFetching")
      div.d-flex.justify-center(v-if="isFetching")
        v-progress-linear(:width="3" rounded color="primary" indeterminate)
      div(v-if="showDefaultItems" v-for="item in defaultItems")
        div.d-flex.align-center.px-4.py-3.clickable.hover-bg(@click="selectItem(item)")
          v-icon.mr-2(size="11" :color="item.iconColor") $yzi-circle
          div.text-sm.flex-grow-1.neutral700--text {{ item.name }}
        v-divider
      div(v-for="item in filteredItems")
        div.d-flex.align-center.px-4.py-3.clickable.hover-bg(@click="selectItem(item)")
          v-icon.mr-2(size="11" :color="item.iconColor") $yzi-circle
          div.text-sm.flex-grow-1.neutral700--text {{ item.name }}
        v-divider
      template(v-if="!filteredItems.length")
        .px-4.py-3 No results match
  .dialogs
    add-edit-list-dialog(v-if="openAddNewListDialog" :open.sync="openAddNewListDialog")
</template>

<script>
import { debounce } from '@/utils'
import { mapGetters, mapActions } from 'vuex'
import AddEditListDialog from '@/components/clinic/dialogs/purchasehub/AddEditListDialog.vue'

export default {
  components: {
    AddEditListDialog
  },
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    attach: {
      type: Boolean,
    },
  },
  data: () => ({
    isLoading: false,
    isFetching: false,
    openDialog: false,
    show: false,
    itemName: null,
    inventoryList: [],
    page: 1,
    pageSize: 20,
    count: 0,
    defaultItems: [
      { id: 'all', name: 'All', iconColor: 'success500' },
      { id: 'orderSoon', name: 'Order soon', iconColor: 'warning500' },
      { id: 'outOfStock', name: 'Out of stock', iconColor: 'danger500' }
    ],
    openAddNewListDialog: false
  }),
  mounted () {
    this.$emit('input', this.defaultItems[1])
  },
  computed: {
    ...mapGetters({ company: 'getCompany' }),
    filteredItems() {
      if (this.itemName) {
        const keyword = this.itemName.toLowerCase()
        return this.inventoryList.filter(item => (item.name.toLowerCase().includes(keyword)))
      }
      return this.inventoryList
    },
    showDefaultItems () {
      return this.page === 1 && (this.itemName === null || this.itemName === '')
    }
  },
  watch: {
    show (val) {
      if (val) {
        this.fetchInventoryList()
      } else {
        this.$emit('closed')
      }
    },
    page () {
      this.fetchInventoryList()
    },
    itemName () {
      this.searchStart()
    },
  },
  methods: {
    ...mapActions(['showMessage']),
    searchStart: debounce(function () {
      this.page = 1
      this.fetchInventoryList()
    }, 750),
    fetchInventoryList () {
      this.isFetching = true
      const params = {
        page_size: this.pageSize,
        page: this.page,
        search: this.itemName
      }
      this.$axios.get(`/clinics/${this.company.slug}/inventory_lists`, { params })
        .then(resp => {
          const results = resp.data.results.map(item => {
            return {
              ...item,
              iconColor: 'info500'
            }
          })
          this.inventoryList = results
          this.count = resp.data.count
        })
        .catch(() => {})
        .finally(() => {
          this.isFetching = false
        })
    },
    selectItem (item) {
      this.$emit('input', item)
      this.$emit('change')
      this.show = false
      this.itemName = ''
    },
  }
}
</script>

<style scoped>
.border-menu {
  border: 1px solid var(--v-basic500);
  box-shadow: none;
}
.error-border-menu {
  border: 1px solid var(--v-danger500);
  box-shadow: none;
}
.search-input {
  position: sticky;
  top: 0px;
  background-color: #FFFFFF !important;
  border-color: #FFFFFF !important;
  z-index: 4;
  padding-top: 8px;
}
</style>